<script>
import api from '@/command/api'
import DetailFormGroup from '@/components/DetailFormGroup'
import { getAction } from '@/command/netTool'

export default {
  name: 'partyBuildingDetail',
  data() {
    return {
      ...api.command.getState(),
      detail: { sort: 0, upDown: 1 }, // upDown: 1 表示下架
      typeList: [],
    }
  },
  mounted() {
    getAction('/base/farmPartyBuilding/getTypeList').then((res) => {
      if (res.code != 200) return
      this.typeList = (res.data || []).map((item) => {
        return {
          name: item.name,
          value: item.id,
        }
      })
    })

    const { id } = this.$route.query
    id &&
      api.command.getDetail.call(this, {
        url: `/base/farmPartyBuilding/detail?id=${id}`,
      })
  },
  methods: {
    getForm1() {
      return {
        title: '基本信息',
        type: 'cardForm',
        data: [
          {
            name: '政策主题',
            type: 'input',
            cols: 12,
            key: 'title',
            maxLength: 40,
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
          },
          {
            name: '政策类型',
            type: 'select',
            cols: 12,
            gutter: 10,
            key: 'partyBuildingTypeId',
            typeData: this.typeList,
            onChange: (val) => {
              this.detail.partyBuildingTypeName = this.typeList.find((f) => f.value == val)?.name || ''
              this.$forceUpdate()
            },
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
          },
          {
            name: '封面图',
            type: 'upload',
            cols: 24,
            maxLength: 1,
            key: 'coverUrl',
            rules: [
              {
                required: true,
                message: '请上传封面图',
                type: 'string',
              },
            ],
          },
          {
            name: '附件添加',
            type: 'upload',
            key: 'fileUrl',
            cols: 24,
            props: {
              multiple: true,
            },
            help: '附件上传多份，仅支持 word文档',
          },
          {
            name: '状态',
            type: 'switch',
            key: 'upDown',
            cols: 24,
            props: {
              checkedChildren: '上架',
              unCheckedChildren: '下架',
            },
            onChange: (val) => {
              this.detail.upDown = val ? 0 : 1
            },
          },
        ],
      }
    },

    getForm7() {
      return {
        type: 'cardForm',
        title: '政策内容',
        cols: 24,
        data: [
          {
            type: 'rich',
            key: 'content',
            cols: 24,
          },
        ],
      }
    },

    getFoot() {
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: (data) => {
            api.command[this.detail.id ? 'edit' : 'create'].call(this, {
              url: `/base/farmPartyBuilding`,
              params: {
                ...data,
                partyBuildingTypeName: this.detail.partyBuildingTypeName,
              },
              isPost: false,
            })
            setTimeout(() => {
              this.$router.back()
            }, 500)
          },
        },
        {
          name: '取消',
          type: 'default',
          onClick: () => {
            setTimeout(() => {
              this.$router.back()
            }, 500)
          },
        },
      ]
      const right = [
        {
          name: '删除',
          popTitle: '确认删除吗?',
          isPop: true,
          type: 'danger',
          ghost: true,
          onClick: () => {
            api.command.delPost.call(this, {
              url: `/base/farmPartyBuilding?id=${this.detail.id}`,
              isPost: false,
            })
            setTimeout(() => {
              this.$router.back()
            }, 500)
          },
        },
      ]
      return {
        left,
        right: this.detail.id && right,
      }
    },
  },
  render() {
    return <DetailFormGroup form={this.detail} foot={this.getFoot()} data={[this.getForm1(), this.getForm7()]} />
  },
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}
</style>
